import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './ActionCenterMessageDetail.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { ConversationMember } from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	recipient: ConversationMember;
	totalRecipients: number;
}

const ActionCenterMessageRecipients: React.FC<Props> = ({
	recipient,
	totalRecipients,
}) => {
	const [showAllRecipients, setShowAllRecipients] = useState(false);
	const { t } = useTranslation();

	return (
		<div className={styles.from}>
			<Text tx='base.toWho' firstUpper inline colon />{' '}
			{recipient?.user?.profile?.fullName}{' '}
			{totalRecipients > 1 && (
				<LinkButton
					title={`+${totalRecipients - 1} ${t('base.next')}`}
					theme={Theme.BLUE}
					onClick={() => setShowAllRecipients(!showAllRecipients)}
				/>
			)}
		</div>
	);
};

export default ActionCenterMessageRecipients;
